import { ReactComponent as PlusIcon } from "./plus.svg";
import { ReactComponent as CloseIcon } from "./close.svg";
import { ReactComponent as BoxIcon } from "./box.svg";
import { ReactComponent as CheckCircleIcon } from "./check-circle.svg";
import { ReactComponent as AlertIcon } from "./alert.svg";
import { ReactComponent as InfoIcon } from "./info.svg";
import { ReactComponent as ErrorIcon } from "./info-hexa.svg";
import { ReactComponent as BoltIcon } from "./bolt.svg";
import { ReactComponent as ArrowUpIcon } from "./arrow-up.svg";
import { ReactComponent as ArrowDownIcon } from "./arrow-down.svg";
import { ReactComponent as FolderIcon } from "./folder.svg";
import { ReactComponent as VideoIcon } from "./videos.svg";
import { ReactComponent as AudioIcon } from "./audio.svg";
import { ReactComponent as GridIcon } from "./grid.svg";
import { ReactComponent as FileIcon } from "./file.svg";
import { ReactComponent as DownloadIcon } from "./download.svg";
import { ReactComponent as ArrowRightIcon } from "./arrow-right.svg";
import { ReactComponent as GroupIcon } from "./group.svg";
import { ReactComponent as BoxIconLine } from "./box-line.svg";
import { ReactComponent as ShootingStarIcon } from "./shooting-star.svg";
import { ReactComponent as DollarLineIcon } from "./dollar-line.svg";
import { ReactComponent as DollarRoundIcon } from "./dollar-round.svg";
import { ReactComponent as TrashBinIcon } from "./trash.svg";
import { ReactComponent as AngleUpIcon } from "./angle-up.svg";
import { ReactComponent as AngleDownIcon } from "./angle-down.svg";
import { ReactComponent as PencilIcon } from "./pencil.svg";
import { ReactComponent as CheckLineIcon } from "./check-line.svg";
import { ReactComponent as CloseLineIcon } from "./close-line.svg";
import { ReactComponent as ChevronDownIcon } from "./chevron-down.svg";
import { ReactComponent as ChevronUpIcon } from "./chevron-up.svg";
import { ReactComponent as PaperPlaneIcon } from "./paper-plane.svg";
import { ReactComponent as LockIcon } from "./lock.svg";
import { ReactComponent as EnvelopeIcon } from "./envelope.svg";
import { ReactComponent as UserIcon } from "./user-line.svg";
import { ReactComponent as CalenderIcon } from "./calender-line.svg";
import { ReactComponent as EyeIcon } from "./eye.svg";
import { ReactComponent as EyeCloseIcon } from "./eye-close.svg";
import { ReactComponent as TimeIcon } from "./time.svg";
import { ReactComponent as CopyIcon } from "./copy.svg";
import { ReactComponent as ChevronLeftIcon } from "./chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "./chevron-right.svg";
import { ReactComponent as SubscriptionsIcon } from "./subscriptions.svg";
import { ReactComponent as UserCircleIcon } from "./user-circle.svg";
import { ReactComponent as TaskIcon } from "./task-icon.svg";
import { ReactComponent as ListIcon } from "./list.svg";
import { ReactComponent as TableIcon } from "./table.svg";
import { ReactComponent as PageIcon } from "./page.svg";
import { ReactComponent as PieChartIcon } from "./pie-chart.svg";
import { ReactComponent as BoxCubeIcon } from "./box-cube.svg";
import { ReactComponent as PlugInIcon } from "./plug-in.svg";
import { ReactComponent as PhoneIcon } from "./phone.svg";
import { ReactComponent as DocsIcon } from "./docs.svg";
import { ReactComponent as MailIcon } from "./mail-line.svg";
import { ReactComponent as HorizontaLDots } from "./horizontal-dots.svg";
import { ReactComponent as ChatIcon } from "./chat.svg";
import { ReactComponent as MoreDotIcon } from "./more-dot.svg";
import { ReactComponent as SettingsIcon } from "./settings.svg";
import { ReactComponent as SignOutIcon } from "./sign-out.svg";
import { ReactComponent as ScheduleIcon } from "./schedule.svg";
import { ReactComponent as WhatsAppIcon } from "./whatsapp.svg";

export {
  DownloadIcon,
  FileIcon,
  GridIcon,
  AudioIcon,
  VideoIcon,
  BoltIcon,
  PlusIcon,
  BoxIcon,
  CloseIcon,
  CheckCircleIcon,
  AlertIcon,
  InfoIcon,
  ErrorIcon,
  ArrowUpIcon,
  FolderIcon,
  ArrowDownIcon,
  ArrowRightIcon,
  GroupIcon,
  BoxIconLine,
  ShootingStarIcon,
  DollarLineIcon,
  DollarRoundIcon,
  TrashBinIcon,
  AngleUpIcon,
  AngleDownIcon,
  PencilIcon,
  CheckLineIcon,
  CloseLineIcon,
  ChevronDownIcon,
  PaperPlaneIcon,
  EnvelopeIcon,
  LockIcon,
  UserIcon,
  CalenderIcon,
  EyeIcon,
  EyeCloseIcon,
  TimeIcon,
  CopyIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  UserCircleIcon,
  SubscriptionsIcon,
  TaskIcon,
  ListIcon,
  TableIcon,
  PageIcon,
  PieChartIcon,
  BoxCubeIcon,
  PlugInIcon,
  PhoneIcon,
  DocsIcon,
  MailIcon,
  HorizontaLDots,
  ChevronUpIcon,
  ChatIcon,
  MoreDotIcon,
  SettingsIcon,
  SignOutIcon,
  ScheduleIcon,
  WhatsAppIcon
};
